import { useState } from 'react';
import { CopyToClipboard } from '../../custom-components/CopyToClipboard';
import { PhoneUniquenessSlideout } from '../../custom-components/PhoneUniquenessSlideout';
import UniversalTag from '../../custom-components/UniversalTag';
import './PhoneDetail.scss';

interface PhoneDetailProps {
  phone: string;
  phoneUniqueness?: string | null;
}

export function PhoneDetail({ phone, phoneUniqueness }: PhoneDetailProps) {
  const [isSlideoutOpen, setIsSlideoutOpen] = useState(false);

  return (
    <div className="phone-detail">
      <CopyToClipboard value={phone} title="Copy phone" />
      <span className="phone-detail__value">{phone}</span>
      {phoneUniqueness && (
        <UniversalTag
          category={phoneUniqueness}
          onClick={() => setIsSlideoutOpen(true)}
        />
      )}

      <PhoneUniquenessSlideout
        isOpen={isSlideoutOpen}
        onClose={() => setIsSlideoutOpen(false)}
      />
    </div>
  );
}
